export default {
  common: {
    home: 'Home',
    product: 'Products',
    service: 'Contact',
    cases: 'Cases',
    news: 'News',
    company: 'About Us',
    platform: 'Platform',
    information: 'Information',
    language: 'Language',
    chinese: 'Chinese',
    english: 'English',
    stockCode: 'Stock Code',
    login: 'Login',
    smartParking: 'Smart Parking',
    smartCharging: 'Smart Charging',
    mobileApp: 'Mobile App',
    smartHardware: 'Smart Hardware',
    smartParkingSystem: 'Smart Parking Management System',
    smartChargingSystem: 'Smart Charging Pile Management System',
    eParking: 'e-Parking',
    parkingHardware: 'Parking Hardware Products',
    enclosedParking: 'Enclosed Parking',
    parkingGuidance: 'Parking Guidance',
    roadsideParking: 'Roadside Parking',
    chargingHardware: 'Charging Pile Hardware Products',
    chargingProducts: 'Charging Pile Products',
    accessControlHardware: 'Access Control Hardware Products',
    accessControlProducts: 'Access Control Products',
    accessControl: 'Access Control',
    aboutUs: 'About Us',
    downloadCenter: 'Download Center',
    contactUs: 'Contact Us',
    companyProfile: 'Company Profile',
    downloadMaterials: '',
    contactInfo: 'Contact Information',
    scenarioSolutions: 'Scenario Solutions',
    parkingChargingSolution: 'Parking & Charging Integrated Operation Revenue Increase Solution',
    unmannedParkingSolution: 'Unmanned Parking Lot Cloud Hosting Solution',
    companyName: 'Beijing Cheyifu Technology Co., Ltd.',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    addressDetail: '2nd Floor, CEC Fintech Building, Building 17, East District, No. 10 Northwest Wangdong Road, Haidian District, Beijing',
    productCenter: 'Product Center',
    followUs: 'Follow Us',
    officialAccount: 'Official Account',
    beianInfo: 'Beijing Public Network Security No. 11010802045620',
    icpInfo: 'Beijing ICP No. 2024085004-1',
    serviceHotline: 'Hotline'
  },
  home: {
    title: 'Welcome to Cheyifu',
    subtitle: 'Professional Auto Financial Solution Provider',
    banner1: 'Cheyifu is a leading enterprise in smart parking and charging ecosystem, providing one-stop services from technology development, technical services to project operation',
    banner2: 'Cheyifu\'s unmanned cloud hosting solution provides parking lot managers with a smart parking scenario construction and operation hosting service',
    banner3: 'Cheyifu\'s integrated parking and charging operation revenue increase solution provides car owners with one-stop "parking + charging" convenient services',
    banner4Alt: 'Cheyifu\'s cloud platform management system',
    getSolution: 'Click to get solution',
    tryExperience: 'Click to experience now',
    companyIntro: 'Company Introduction',
    companyDetail: 'Beijing Cheyifu Technology Co., Ltd. (Stock Code: 873063) is a “Specialized, Sophisticated, Distinctive and Novel” enterprise listed on the Beijing Stock Exchange’s NEEQ. With over a decade of industry service, the company integrates full-process capabilities spanning hardware and software design, R&D, production, sales, service, and operations. It is recognized as a pioneer and leader in the smart parking and smart charging sectors.',
    ourProducts: 'Continuous deep cultivation of products and services',
    parkingService: 'Enclosed Parking Service',
    parkingDesc: 'Smart parking lot + cloud platform management mode reduces parking lot operating costs, improves resource management efficiency, and realizes asset appreciation. Through refined management, it provides car owners with efficient, smart and convenient parking services',
    serviceAdvantage: 'Service Advantages',
    servicePoint1: 'Intelligent transformation of parking lots, standardized operations',
    servicePoint2: 'Service upgrading, comprehensive service for users',
    servicePoint3: 'Intelligent data analysis, providing support for operational decision-making',
    roadsideParking: 'Roadside Parking Service',
    roadsideParkingDesc: 'Relying on cloud platforms and smart hardware, it enables refined management of roadside parking spaces, including monitoring, administration, and inspection. This improves resource efficiency and provides vehicle owners with smart, convenient parking services',
    roadsideAdvantage1: 'Improve parking space control level, rational use of resources',
    roadsideAdvantage2: 'Intelligent recovery improves parking payment rate',
    roadsideAdvantage3: 'Parking space inspection improves management efficiency and reduces operating costs',
    chargingService: 'Intelligent Charging Service',
    chargingServiceDesc: 'Relying on the cloud platform, it realizes centralized control and remote control of charging piles. Help operators improve operational efficiency, reduce costs, and provide users with convenient and transparent charging services',
    chargingAdvantage1: 'Improve charging pile control level, rational use of resources',
    chargingAdvantage2: 'Parking lot + parking space + charging pile refined management',
    chargingAdvantage3: 'Convenient charging for car owners, improving travel efficiency',
    accessControlService: 'Smart Access Control Service',
    accessControlServiceDesc: 'Create highly professional access control management services from multiple aspects such as regular access, centralized control, and complex access',
    accessControlAdvantage1: 'Optimize venue access control management, improve management efficiency',
    accessControlAdvantage2: 'Full scene coverage, flexible solution configuration',
    accessControlAdvantage3: 'Solve the problem of difficult collection of personnel information',
    smartHardware: 'Intelligent Hardware Products',
    parkingLot: 'Parking Lot',
    chargingEnergy: 'Charge & Store',
    parkingLotHardware: 'Parking Lot Intelligent Hardware',
    parkingHardware: 'Parking Intelligent Hardware',
    chargingHardware: 'Charging Intelligent Hardware',
    accessControlHardware: 'Access Control',
    ownPlatform: 'Own Platform',
    ownHardware: 'Own Hardware',
    parkingLotHardwareDesc: 'We provide integrated solutions built upon parking controllers and barrier gates, supported by essential peripheral devices to form a complete system.',
    parkingHardwareDesc: 'We provide integrated solutions built upon parking controllers and barrier gates, supported by essential peripheral devices to form a complete system.',
    chargingHardwareDesc: 'Provide charging piles, charging cabinets, charging management systems and other charging full-range intelligent hardware',
    accessControlHardwareDesc: 'Provide visitor gate machines, pedestrian access gates, access control management systems and other personnel access full-range intelligent hardware',
    knowMore: 'Learn more',
    learnMore: 'Learn more',
    viewMore: 'View more',
    customerTrust: 'Customer trust and support',
    jiamusiProject: 'Jiamusi Static Traffic Management Project',
    jiamusiProjectDesc: 'Jiamusi City, Heilongjiang Province, has built a city-wide smart parking platform to integrate on-street and off-street parking resources, integrate intelligent sensing devices with integrated parking and charging management, and realize digital governance of parking resources throughout the city.',
    heilongjiang: 'Heilongjiang',
    guiyangProject: 'Guiyang Integrated Park & Charge Initiative',
    guiyangProjectDesc: 'Guiyang Economic Development Zone has built an urban parking and charging integration platform covering 9,800+ parking spaces, integrating roadside parking, enclosed parking lots, and fast charging stations to realize full-chain intelligence of "management-operation-data-services".',
    guizhou: 'Guizhou',
  },
  product: {
    title: 'Products',
    description: 'We offer a variety of automotive financial products',
    systemTitle: 'Unattended, Smart Parking Management System',
    systemAlt: 'Smart Parking Cloud Management Platform',
    productOverview: 'Product Overview',
    productDesc: 'Our cloud-based platform ensures uninterrupted vehicle flow through centralized control of multiple parking lots. It integrates comprehensive capabilities including remote monitoring, access control, smart billing, and real-time data sync. All systems are backed by 24/7 professional support that guarantees second-level response to any incident.',
    userPain: 'User Pain Points',
    painPoint1: 'Low Parking Lot Management Efficiency',
    painDesc1: 'Traditional parking lot management relies on manual labor, which is costly and inefficient',
    painPoint2: 'Insufficient Security',
    painDesc2: 'Traditional parking lots lack real-time monitoring and customer service, resulting in insufficient security',
    painPoint3: 'Poor Parking Experience',
    painDesc3: 'Car owners have difficulty finding parking lots and spaces, payment methods are cumbersome, and parking records are difficult to find',
    painPoint4: 'Difficult Operation Data Analysis',
    painDesc4: 'Traditional parking lot operation data analysis is difficult and cannot provide support for operation decisions',
    productFeatures: 'Product Features',
    feature1: 'Intelligent Parking Lot Management',
    featureDesc1: 'Manage parking lot operation information, intelligent equipment information, issue parking charging rules, set parking lot channel permissions, and set parking lot entrance and exit voice broadcasts.',
    feature2: 'Remote Intelligent Operation and Maintenance',
    featureDesc2: 'Manage parking lot operation information using on-site order maintenance + 24-hour on-duty seats to achieve a combination of far and near, which can solve on-site emergency problems while saving labor costs in the parking lot, achieving cost reduction and efficiency increase.',
    feature3: 'Parking Lot Collaborative Operation',
    featureDesc3: 'Manage parking lot operation information. For member services opened in parking lots, they can be handled online, such as monthly card vehicles, annual card vehicles, stored value vehicles, free vehicles, purchase of coupons and other services.',
    feature4: 'Operation Data Analysis',
    featureDesc4: 'Manage parking lot operation information. Use on-site order maintenance + multi-dimensional dynamic intelligent analysis of parking lot business data, financial data, and operating indicators to provide support for efficient, accurate, and comprehensive business decisions for parking lots.',
    acs: {
      title: 'Access Control',
      products: {
        swingGate: 'Swing Gate',
        singleFullHeightTurnstile: 'Single Door Full Height Turnstile',
        wingGate: 'Wing Gate',
        tripodTurnstile: 'Tripod Turnstile',
        faceRecognition: 'Face Recognition Device',
        integratedAccessControl: 'Integrated Access Control',
        singleDoorBiDirectionalController: 'Single Door Bi-directional Controller',
        doubleDoorBiDirectionalController: 'Double Door Bi-directional Controller',
        fourDoorUniDirectionalController: 'Four Door Uni-directional Controller',
        cardIssuer: 'Card Issuer',
        universalCardIssuer: 'Universal Card Issuer',
        cardReader: 'Card Reader',
        compositeCardReader: 'Composite Card Reader',
        singleDoorMagneticLock: 'Single Door Magnetic Lock',
        doubleDoorMagneticLock: 'Double Door Magnetic Lock',
        doorOpenButton: 'Door Open Button',
        icIdCard: 'IC/ID Card',
        icIdKeyCard: 'IC/ID Key Card'
      }
    },
    applet: {
      title: 'e-Parking',
      description: 'Car owners can quickly and accurately find parking lot information, charging pile information, price information, discount information, and availability status on the e-Parking mini-program. Quick navigation guides car owners to easily find parking lots or charging piles, providing integrated parking and charging services for car owners. At the same time, e-Parking also provides basic services such as online payment, electronic invoices, parking space rental, monthly card renewal, coupon purchase, and order inquiry.',
      featuresTitle: 'Product Features'
    },
    charge: {
      overviewTitle: 'Product Overview',
      overviewDescription: 'This cloud platform enables centralized monitoring, management, and optimization of charging piles with real-time remote control. It also provides driver services like navigation and pricing to enhance operational efficiency and user experience.',
      painPointsTitle: 'User Pain Points',
      painPoints: {
        lowEfficiency: 'Low Efficiency in Power Station Management',
        lowEfficiencyDesc: 'Power station management relies on manual work, which is costly and inefficient.',
        insufficientSafety: 'Insufficient Safety Assurance',
        insufficientSafetyDesc: 'Unable to achieve remote monitoring and operation and maintenance of equipment, insufficient safety assurance.',
        poorExperience: 'Poor Charging Experience',
        poorExperienceDesc: 'It is difficult for car owners to find power stations and charging piles, payment methods are cumbersome, and charging records are difficult to query.',
        dataAnalysisDifficulty: 'Difficulty in Operational Data Analysis',
        dataAnalysisDifficultyDesc: 'It is difficult to analyze the operation data of power stations, which cannot provide support for operational decision-making.'
      },
      featuresTitle: 'Product Features',
      features: {
        smartManagement: 'Smart Power Station Management',
        smartManagementDesc: 'Manage power station operation information, charging pile equipment information, and publish power station billing rules.',
        smartMaintenance: 'Smart Power Station Maintenance',
        smartMaintenanceDesc: 'Remotely control the restart, deactivation and other operations of charging piles. Support the dispatch and tracking of equipment alarm work orders to ensure users\' electricity services.',
        collaborativeOperation: 'Collaborative Power Station Operation',
        collaborativeOperationDesc: 'Online membership activation, charging card application, coupon purchase and other services.',
        dataAnalysis: 'Operational Data Analysis',
        dataAnalysisDesc: 'Multi-dimensional dynamic intelligent analysis of power station business data, financial data, and operating indicators to provide support for efficient, accurate, and comprehensive business decisions for parking lots.'
      }
    },
    chargeHw: {
      title: 'Smart Charging',
      hardware: {
        dc30kw: '30KW DC Charging Pile',
        ac: 'AC Charging Pile',
        dc: 'DC Charging Pile',
        dualGun: 'Dual Gun Charging Terminal Cabinet',
        singleGun: 'Single Gun Charging Terminal Cabinet',
        liquidCooled: 'Liquid Cooled Energy Storage Cabinet',
        heavyTruck: 'Heavy Truck DC Charging Pile',
        splitDc: 'DC Split Charging Station',
        bikeRobot: 'Bicycle Charging Robot',
        eBike: 'Electric Bicycle Charging Pile',
        waterproofSocket: 'Waterproof Socket'
      },
      alt: {
        dc30kw: 'Cheyifu 30KW DC Charging Pile',
        ac: 'Cheyifu AC Charging Pile',
        dc: 'Cheyifu DC Charging Pile',
        dualGun: 'Cheyifu Dual Gun Charging Terminal Cabinet',
        singleGun: 'Cheyifu Single Gun Charging Terminal Cabinet',
        liquidCooled: 'Cheyifu Liquid Cooled Energy Storage Cabinet',
        heavyTruck: 'Cheyifu Heavy Truck DC Charging Pile',
        splitDc: 'Cheyifu DC Split Charging Station',
        bikeRobot: 'Cheyifu Bicycle Charging Robot',
        eBike: 'Cheyifu Electric Bicycle Charging Pile',
        waterproofSocket: 'Cheyifu Waterproof Socket',
        banner: 'Cheyifu Smart Charging Hardware Display'
      }
    },
    close: {
      tabs: {
        closePark: 'Closed Parking',
        guidance: 'Parking Guidance',
        road: 'Road Parking'
      },
      labels: {
        new: 'New'
      },
      products: {
        // Closed Parking
        standardUnmanned: 'Standard Unmanned Machine',
        unmannedGuard: 'Unmanned Guard',
        licensePlateRecognition: 'License Plate Recognition Machine',
        ledLicensePlate: 'LED License Plate Recognition',
        licensePlateBarrier: 'License Plate Barrier Machine',
        integratedAuxiliary: 'Integrated Auxiliary Machine',
        vehicleTypeJudge: 'Vehicle Type Judge',
        barrierGate: 'Barrier Gate',
        advertisingBarrier: 'Advertising Barrier',
        airBarrierHost: 'Air Barrier Host',
        // Parking Guidance
        selfPayment: 'Self-payment Machine',
        vacancyScreen: 'Vacancy Screen',
        monitoringCamera: 'Monitoring Camera',
        siteServer: 'Site Server',
        vehicleDetector: 'Vehicle Detector',
        antiCrushRadar: 'Anti-crush Radar',
        parkingCamera: 'Parking Camera',
        guidanceScreen: 'Guidance Screen',
        // Road Parking
        highCamera: 'High Camera',
        smartParkingPile: 'Smart Parking Video Pile',
        parkingLock: 'Parking Lock',
        inspectionVehicle: 'Inspection Vehicle',
        handheldDevice: 'Handheld Device',
        geomagneticTerminal: 'Geomagnetic Terminal'
      }
    }
  },
  service: {
    title: 'Service Support',
    description: 'Provide comprehensive service support for customers',
    contactTitle: 'Contact Information',
    emailTitle: 'Official Email',
    email: 'cheyifu@cheyifu.com.cn',
    businessTitle: 'Business Cooperation',
    businessPhone: '18601939795',
    serviceTitle: 'Service Hotline',
    servicePhone: '400-623-9981',
    messageTitle: 'Online Message',
    formName: 'Your Name',
    formContact: 'Contact Information',
    formAddress: 'Address',
    formCompany: 'Company Name',
    formRequirement: 'Project Requirements',
    formMessage: 'Your Message',
    checkbox1: 'Smart Parking Solution',
    checkbox2: 'Intelligent Charging',
    checkbox3: 'Access Control Solution',
    checkbox4: 'Business Cooperation',
    checkbox5: 'Other',
    submitBtn: 'Submit Now',
    // Form validation and alert messages
    formValidateName: 'Please enter your name',
    formValidateContact: 'Please enter your contact information',
    formSubmitSuccess: 'Submission successful',
    formAlertTitle: 'Alert',
    requiredName: 'Please enter your name',
    requiredPhone: 'Please enter your contact information'
  },
  cases: {
    title: 'Success Cases',
    description: 'Learn about our successful partners',
    case1Alt: 'Cheyifu Static Traffic Governance Project: Jiamusi Static Traffic Neutralization Governance Project',
    case1Title: 'Jiamusi City Static Traffic Comprehensive Governance Project',
    case1Desc: 'Jiamusi City, Heilongjiang Province, has built a city-wide smart parking platform, integrated on-street and off-street parking resources, integrated intelligent sensing equipment and integrated parking and charging management, realizing digital governance of parking resources throughout the city.',
    case1Address: 'Heilongjiang',
    case2Alt: 'Cheyifu Integrated Parking and Charging Project',
    case2Title: 'Guiyang Economic Development Zone Urban-level Integrated Parking and Charging Project​',
    case2Desc: 'Guiyang Economic Development Zone has built a city-level integrated parking and charging platform covering 9,800+ parking spaces, integrating roadside parking, enclosed parking lots, and fast charging station resources, realizing the entire chain of "management-operation-data-service" intelligence.',
    case2Address: 'Guizhou'
  },

  company: {
    title: 'About Us',
    description: 'Learn about Cheyifu\'s development history and corporate culture',
    introTitle: 'Company Introduction',
    introDesc1: 'Beijing Cheyifu Technology Co., Ltd. (Stock Code: 873063) is a “Specialized, Sophisticated, Distinctive and Novel” enterprise listed on the Beijing Stock Exchange’s NEEQ. With over a decade of industry service, the company integrates full-process capabilities spanning hardware and software design, R&D, production, sales, service, and operations. It is recognized as a pioneer and leader in the smart parking and smart charging sectors.',
    introDesc2: '',
    valuesTitle: 'Core Values',
    visionTitle: 'Vision',
    visionDesc: 'To become the most competitive travel service enterprise',
    missionTitle: 'Mission',
    missionDesc: 'To improve travel services through technological innovation',
    valuesSubTitle: 'Values',
    valuesDesc: 'Integrity, Gratitude, Unity, Pursuit of Excellence',
    purposeTitle: 'Purpose',
    purposeDesc: 'Let users benefit, let customers worry-free',
    qualificationsTitle: 'Qualifications',
    agencyTitle: 'Corporate Qualifications',
    authorTitle: 'Authoritative Qualifications',
    authorityTitle: 'Authority Qualification',
    authorityAlt: 'Authority Qualification',
    aboutTitle: 'About Us',
    aboutDesc: 'The company organically combines smart parking, smart charging with government, management companies, enabling partners and car owners through Internet and IoT technologies to create a safe, convenient and comfortable smart vehicle ecosystem. Relying on the experience of Cheyifu Cloud SaaS platform, the company has independently developed distributed unmanned robots based on "IoT+AI" technology and smart charging piles based on "differential power" technology, currently covering more than 100 cities and serving thousands of customers.',
    advantageTitle: 'Company Advantages',
    professionalTitle: 'Our Professionalism',
    professionalDesc: 'The company\'s main business covers software research and development, hardware production in multiple fields such as urban smart parking, smart charging, smart city IoT, smart livelihood services and regional e-commerce. The company organically combines parking, charging, livelihood services with government, platform companies, business partners and car owners through the integration of Internet and IoT technologies.',
    teamTitle: 'Our Team',
    teamDesc: 'A comprehensive tactical team. To meet the diverse and intelligent customer needs, Cheyifu not only has multi-scenario reusable IOT platforms, AI technology platforms, and Cheyifu Cloud SaaS platforms, but also has industry-experienced management teams, pre-sales engineers, hardware teams, cost advantages of self-developed hardware products, and replicable project experience.',
    technologyTitle: 'Technical Advantages',
    technologyDesc: 'Technological innovation is the foundation of our business. We pursue excellence to enhance user experience, scientifically layout the entire industry chain, work together for a better future, gather top talents, and transform achievements to support the main business.',
    partnerTitle: 'Partners',
    honorTitle: 'Honor Qualifications'
  },

  news: {
    title: 'News',
    description: 'Latest industry trends and company news',
    all: 'All',
    companyNews: 'Company News',
    industryNews: 'Industry News',
    back: 'Back'
  },
  platform: {
    title: 'Platform Introduction',
    bannerAlt: 'Integrated parking and charging operation revenue solution, providing one-stop "parking + charging" convenient services for car owners',
    solutionOverview: 'Solution Overview',
    solutionDesc: 'An integrated solution that combines parking facilities, spaces, and chargers to tackle destination charging. Key features include locating chargers/spaces, precise navigation, and dedicated space access control.',
    fineManagement: 'Site + Parking + Charging Fine Management',
    fineManagementAlt: 'Cheyifu parking and charging fine management',
    solutions: 'Solutions',
    efficientParkingControl: 'Efficient Parking Management',
    efficientParkingControlDesc: 'Integrated parking and charging, effectively improving parking utilization',
    chargingParkingManagement: 'Charging Parking Management',
    chargingParkingManagementDesc: 'Professional team on duty, 7*24 hours guarding parking and charging experience',
    flexibleCooperation: 'Flexible Cooperation Model',
    flexibleCooperationDesc: 'Investment + operation, construction + agent operation, existing pile access operation',
    scientificInvestment: 'Scientific Investment Calculation',
    scientificInvestmentDesc: 'Data calculation of vehicle-to-pile ratio, scientific investment to ensure returns',
    businessValue: 'Business Value',
    comprehensiveCostReduction: 'Reduce Cost',
    comprehensiveCostReductionDesc1: 'Cost Reduction',
    comprehensiveCostReductionDesc2: 'Efficiency Boost',
    comprehensiveCostReductionDesc3: 'Energy Saving',
    diversifiedIncome: 'Boost Revenue',
    diversifiedIncomeDesc1: 'Efficiency',
    diversifiedIncomeDesc2: 'Expansion',
    diversifiedIncomeDesc3: 'Enforcement',
    longTermQualityImprovement: 'Enhance Quality',
    longTermQualityImprovementDesc1: 'Upgrade',
    longTermQualityImprovementDesc2: 'Expansion',
    longTermQualityImprovementDesc3: 'Refresh',
    applicationScenarios: 'Application Scenarios',
    applicationScenariosAlt: 'Cheyifu parking and charging application scenarios',
    smartCity: 'Smart City',
    smartCommunity: 'Smart Community',
    commercialComplex: 'Commercial Complex',
    transportationHub: 'Transportation Hub',
    hospital: 'Hospital',
    scenicSpot: 'Scenic Spot'
  },
  platformCloud: {
    solutionOverview: 'Solution Overview',
    solutionDesc: 'Cheyifu delivers an all-in-one smart parking solution (hardware + platform + service) for operators, from construction to managed operations. We create unattended smart parking lots to help clients lower costs, enhance service, and boost income.',
    solutions: 'Solutions',
    oneStopService: 'One-stop Service',
    oneStopServiceDesc: 'Hardware + platform + service, creating unmanned one-stop service',
    intelligentOperation: 'Intelligent Operation and Maintenance',
    intelligentOperationDesc: 'On-site order maintenance + back-end duty seats, comprehensively ensuring fast entry and exit for car owners',
    valueAddedOperation: 'Value-added Operation',
    valueAddedOperationDesc: 'Order income data monitoring and analysis, scientific decision-making operation',
    flexibleCooperation: 'Flexible Cooperation Model',
    flexibleCooperationDesc: 'Multiple cooperation models, reducing one-time investment capital costs',
    businessValue: 'Business Value',
    significantCostReduction: 'Reduce Cost',
    significantCostReductionDesc1: 'Cost Reduction',
    significantCostReductionDesc2: 'Efficiency Boost',
    significantCostReductionDesc3: 'Hands-free',
    significantIncomeIncrease: 'Boost Revenue',
    significantIncomeIncreaseDesc1: 'Efficient',
    significantIncomeIncreaseDesc2: 'Secure',
    significantIncomeIncreaseDesc3: 'Profitable',
    longTermQualityImprovement: 'Enhance Quality',
    longTermQualityImprovementDesc1: 'Upgrade',
    longTermQualityImprovementDesc2: 'Expansion',
    longTermQualityImprovementDesc3: 'Refresh'
  },
  casesDetail: {
    projectIntroduction: 'Project Introduction',
    projectIntroductionDesc1: 'Jiamusi City‘s citywide smart parking platform integrates all parking resources and smart devices with unified management, enabling digital governance across the entire region.',
    projectIntroductionDesc2: '',
    projectPlan: 'Project Plan',
    globalIntelligentCoverage: 'Global Intelligent Coverage',
    globalIntelligentCoverageDesc: 'Access to 100+ parking lots, 3000+ on-street parking spaces (focusing on old urban areas such as Chang\'an Road), eliminating regulatory blind spots',
    multimodalPerceptionTechnology: 'Multimodal Perception Technology',
    multimodalPerceptionTechnologyDesc: 'Deploy geomagnetic, high-low video piles and other equipment to monitor parking space status in real-time',
    parkingChargingIntegration: 'Parking-Charging Integration',
    parkingChargingIntegrationDesc: 'Renovate and build 4515 parking spaces, with 557 charging piles',
    contactlessPayment: 'Contactless Payment and Collection',
    contactlessPaymentDesc: 'Support ETC parking payment and efficient collection of arrears',
    advancedTechnologyIntegration: 'Advanced Technology Integration',
    advancedTechnologyIntegrationDesc: 'Apply high-level video + low-level video piles + collection vehicles + sign linkage management',
    parkingChargingCollaboration: 'Parking-Charging Collaboration Network',
    parkingChargingCollaborationDesc: 'Build 5 fast charging stations (110 fast charging guns) to meet the rapid energy replenishment of new energy vehicles',
    fullProcessClosedLoop: 'Full Process Closed-Loop Service',
    fullProcessClosedLoopDesc: 'Covering the full-cycle management of "construction-operation-maintenance-assets", responding to government smart platform requirements',
    // Guiyang Economic Development Zone Case
    projectIntroduction2: 'Project Introduction',
    projectIntroductionDesc1_2: 'A city-level integrated platform in Guiyang Economic Development Zone covers 9,800+ parking spaces. By integrating on-street parking, off-street garages, and fast-charging stations, it achieves intelligent, end-to-end control of management, operations, data, and services.',
    projectIntroductionDesc2_2: '',
    projectPlan2: 'Project Plan',
    globalResourceIntegration: 'Global Resource Integration',
    globalResourceIntegrationDesc: 'Full coverage access to 9,800+ parking spaces on and off roads, supporting ETC payment and arrears recovery',
    advancedTechnologyIntegration2: 'Advanced Technology Integration',
    advancedTechnologyIntegrationDesc: 'Application of high-position video + low-position video piles + recovery vehicles + identification signs for linkage management',
    parkingChargingNetwork2: 'Parking-Charging Collaborative Network',
    parkingChargingNetworkDesc: 'Construction of 5 fast charging stations (110 fast charging guns) to meet the rapid energy replenishment needs of new energy vehicles',
    closedLoopService2: 'Full-process Closed-loop Service',
    closedLoopServiceDesc: 'Covering the entire life cycle management of "construction-operation-maintenance-assets", responding to government smart platform requirements'
  },
  information: {
    title: 'Industry Information',
    description: 'Auto finance industry related information'
  }
}